import { Grid } from "@mui/material";
import React from "react";

const sharedStyles = {
  fontSize: "12px",
  fontWeight: "700",
  padding: "2px 0",
};

const InfoGridItem = ({ infoKey, value }) => {
  return (
    <>
      <Grid
        item
        xs={5}
        sx={{ width: "100px", color: "var(--gray-text)", ...sharedStyles }}
      >
        <p>{infoKey}</p>
      </Grid>
      <Grid item xs={7} sx={{ ...sharedStyles }}>
        <p style={{ wordBreak: "break-all" }}>: {value}</p>
      </Grid>
    </>
  );
};

export default InfoGridItem;
